const locales = ["ko", "en"];
const DEFAULT_LOCALE = "ko";
const i18nConfig = {
  i18n: {
    defaultLocale: DEFAULT_LOCALE,
    locales
  }
};
const HEADER_KEY_LOCALE = "FlexTeam-Locale";
const COOKIE_KEY_LOCALE = "FlexTeam-Locale";

export { COOKIE_KEY_LOCALE, DEFAULT_LOCALE, HEADER_KEY_LOCALE, i18nConfig, locales };
//# sourceMappingURL=index.mjs.map
